    // Debugging: Check if Colorbox is loaded
    if ($.colorbox) {
      console.log("Colorbox loaded successfully.");
    } else {
      console.error("Colorbox failed to load.");
    }

  // Attach Colorbox to All Buttons at Once
    $(".lightbox-btn").each(function () {
      const imageSrc = $(this).data("src");
      const galleryGroup = $(this).data("gallery"); // Get gallery name
      
      // Replace button with hidden anchor for Colorbox compatibility
      $(this).after(
        `<a href="${imageSrc}" class="lightbox-anchor" rel="${galleryGroup}" style="display: none;"></a>`
      );
    });

    // Initialize Colorbox on Anchors
    $(".lightbox-anchor").colorbox({
      maxWidth: "90%",
      maxHeight: "90%",
      transition: "fade",
      rel: "product-gallery", // Ensures proper grouping
      next: theme.icons.right,
            previous: theme.icons.left,
            close: theme.icons.close,
      photo: true,
    });

    // Open Colorbox on Button Click
    $(document).on("click", ".lightbox-btn", function () {
      $(this).next(".lightbox-anchor").click(); // Trigger the hidden anchor
    });
  

